import { OutlawCoreConfig } from '../types';
import { buildConfig } from '../generators/core-config.generator';
import { InjectionToken, Provider } from '@angular/core';

export const OUTLAW_CORE_CONFIG = new InjectionToken<OutlawCoreConfig>('OUTLAW_CORE_CONFIG');

export function provideOutlawConfig(config: Partial<OutlawCoreConfig>): Provider[] {
  const mergedConfig = buildConfig(config);

  return [{ provide: OUTLAW_CORE_CONFIG, useValue: mergedConfig }];
}
